import type { AnyItem, ResolvedMonospacePrimitiveField } from '#layers/data-model/public';
import { randomUuid } from '#layers/base/public';
import { getStaticDefaultValue, getTypename, isConnectorManaged, isPrimitiveTypeNumber, resolveFieldParser } from '#layers/data-model/public';

export function createFormDefaultValues(
	primitiveFields: ResolvedMonospacePrimitiveField[],
): AnyItem {
	const defaults: AnyItem = {};

	for (const field of primitiveFields) {
		if (field.defaultValue != null) {
			if (isConnectorManaged(field.defaultValue)) continue;

			const staticValue = getStaticDefaultValue(field.defaultValue);

			if (staticValue !== undefined) {
				const parser = resolveFieldParser(getTypename(field.type));
				defaults[field.apiName] = parser?.parse ? parser.parse(staticValue) : staticValue;
			}
		}
		else if (!field.isNullable) {
			let value;
			const typename = getTypename(field.type);

			if (typename === 'uuid') {
				value = randomUuid();
			}
			else if (typename === 'string') {
				value = '';
			}
			else if (typename === 'boolean') {
				value = false;
			}
			else if (isPrimitiveTypeNumber(field.type)) {
				value = 0;
			}

			if (value !== undefined) {
				defaults[field.apiName] = value;
			}
		}
	}

	return defaults;
}
